import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./global-control-query-key-factory";

/**
 * function making api call to get details of standard baseline using baseline id
 *
 * @param {string} baselineId - uuid of baseline
 * @returns array of object
 */
export const getBaseline = async ({ baselineId }: { baselineId: string }) => {
  const data = await Brm.baselineApi.getStandardBaselineByID(baselineId);
  return [data];
};

interface IUseStandardBaseline {
  baselineId: string;
  options: QueryOption<typeof getBaseline>;
}

/**
 * React-query hook for getting Baseline details by id
 *
 * @param {string} baselineId - uuid of the baseline
 * @param {object} options- configuration for useStandardBaseline hook
 * @returns react-query for getBaseilne
 */
export const useStandardBaseline = ({ baselineId, options = {} }: IUseStandardBaseline) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.standardBaselineKeys.baseline(baselineId),
    queryFn: () => getBaseline({ baselineId }),
  });
};
